// extracted by mini-css-extract-plugin
module.exports = {"link":"restriction_link__1z1an","body":"restriction_body__k_etn","text":"restriction_text__3JnHt"};